import {
  CircularProgress,
  createStyles,
  Divider,
  Grid,
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from "@material-ui/core";
import { Send } from "@material-ui/icons";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import useLandingFunctions from "../../../../../hooks/useLandingFunctions";
import { PFXSocialComponent } from "../../../../../models/Interfaces";
import { TITLE_FONTSIZE_BASE } from "../../../../../pages/Landing";
import { selectComponentDimensions } from "../../../../../redux/slices/landingSlice";

interface INewsletter {
  data: PFXSocialComponent;
  id: string;
}

const Newsletter = ({ data, id }: INewsletter) => {
  const { width, height } = useSelector(selectComponentDimensions);
  const { handleInsertNewsletterClient } = useLandingFunctions();

  const [input, setInput] = useState<string>("");
  const [strobe, setStrobe] = useState<boolean>(false);
  const [load, setLoad] = useState<boolean>(false);

  const componentStyles = useMemo(
    () => ({
      title: {
        fontSize: `${data.title?.fontSizeMultiplier ?? 1 * TITLE_FONTSIZE_BASE}rem`,
        color: data.title?.color ?? "#1a1a1a",
        textAlign: (data.title?.alignment ?? "center") as any,
        fontWeight: data.title?.fontWeight as any,
        fontFamily: data.title?.fontFamily,
      },
    }),
    [data]
  );

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      "@keyframes strobe": {
        "0%": {
          backgroundColor: "#16d158",
        },
        "100%": {
          backgroundColor: data.backgroundColor ?? "white",
        },
      },
      container: {
        maxWidth: width,
      },
      root: {
        minHeight: height / 2.5,
        transitionProperty: "min-height, height",
        transitionDuration: "400ms",
        backgroundColor: data.backgroundColor ?? "white",
        padding: 30,
        "&.animate": {
          animation: "$strobe 2s ease-in",
        },
      },
      title: { ...componentStyles.title },
      titleTextInput: { ...componentStyles.title, height: "100%" },
      titleDiv: {
        // minHeight: `calc(${height / 2.2}px - 13px)`,
        width: "100%",
        borderRadius: 5,
        marginTop: 8,
      },
      titleInput: {
        // height: `calc(${height / 2.2}px - 13px)`,
        width: "100%",
        borderRadius: 5,
      },
      inputDiv: {
        marginTop: 8,
      },
      inputroot: {
        padding: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 400,
      },
      input: {
        marginLeft: theme.spacing(1),
        flex: 1,
      },
      iconButton: {
        padding: 10,
        color: data.iconColor ?? "green",
      },
      divider: {
        height: 28,
        margin: 4,
      },
    })
  );

  const classes = useStyles();

  const handleInsert = async () => {
    setLoad(true);
    const w = await handleInsertNewsletterClient(input);
    if (!!w?.success) setStrobe(true);
    setTimeout(() => {
      setStrobe(false);
      setInput("");
      setLoad(false);
    }, 2000);
  };

  return (
    <Grid
      container
      id={`landing-component-${id}`}
      className={`${strobe ? "animate" : ""} ${classes.root}`}
      justifyContent="center"
      alignItems="center">
      <Grid
        item
        container
        className={classes.container}
        alignItems="center"
        wrap="nowrap"
        justifyContent="space-evenly"
        direction="column">
        <Grid item className={classes.titleDiv} id={`title-${id}`}>
          <Typography className={classes.title}>{strobe ? "Agregado exitosamente" : data?.title?.content}</Typography>
        </Grid>
        <Grid
          item
          id={`button-${id}`}
          className={classes.inputDiv}
          container
          justifyContent="center"
          alignItems="center">
          <Paper component="form" className={classes.inputroot}>
            <InputBase
              className={classes.input}
              placeholder="Tu correo electrónico"
              inputProps={{ "aria-label": "search google maps" }}
              onChange={e => setInput(e.target.value)}
              value={input}
            />
            <Divider className={classes.divider} orientation="vertical" />
            <IconButton disabled={load} className={classes.iconButton} aria-label="directions" onClick={handleInsert}>
              {load ? <CircularProgress size={23} /> : <Send />}
            </IconButton>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Newsletter;
